// extracted by mini-css-extract-plugin
export default {"wrapper":"hM-z","firstToReview":"iM-z","productCards":"jM-z","productCard":"kM-z","stars":"lM-z","hidden":"mM-z"};